import { useEffect, useState, FC } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import Loader from '../../../../common/Loader';

const objErrorValues = {
    isShow: false,
    isError: false,
    message: ""
}

var base_url = window.origin + '/classic/';
const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

const EmailAddressVerification: FC = () => {
    const [errorValues, setErrorValues] = useState<any | ''>(objErrorValues);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        validateEmailCode();
    }, []);

    const validateEmailCode = async () => {
        if (NODE_ENV === "development") {
            base_url = REACT_APP_TIMELIVE_API_URL as string;
        }
        setIsLoading(true);
        setErrorValues({
            ...errorValues,
            isShow: false,
            isError: false,
            message: ""
        });
        try {
            const params = new URLSearchParams(window.location.search);
            const codeValue = params.get('VAQS');
            const response: any = await fetch(`${base_url}api/Account/ValidateEmailAddress/${codeValue}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const json = await response.json();
            if (json.StatusCode === "200") {
                setErrorValues({
                    ...errorValues,
                    isShow: false,
                    isError: false,
                    message: json.message
                });
                alert(json.message);
                logOut();
            } else if (json.StatusCode === "404") {
                setErrorValues({
                    ...errorValues,
                    isShow: true,
                    isError: true,
                    message: json.message
                });
            } else {
                setErrorValues({
                    ...errorValues,
                    isShow: true,
                    isError: true,
                    message: json.message
                });
            }
        } catch {

        } finally {
            setIsLoading(false);
        }
    }

    const logOut = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = `${window.origin}`;
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="d-flex flex-column flex-root" style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100vh',
                width: '100%',
                position: 'relative'
            }}>
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-lg-row-fluid">
                        <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                            <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
                            <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                Fast, Efficient and Productive
              </h1>
              <div className="color-TextDarkBlue fs-base text-center fw-semibold">
                Discover the ultimate time tracking software designed to streamline your business operations.
                <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
              </div>
                            {/* <div className="text-gray-600 fs-base text-center fw-semibold">
                                In this kind of post, <a href="#" className="opacity-75-hover text-primary me-1">the blogger</a>
                                introduces a person they’ve interviewed <br /> and provides some background information about
                                <a href="#" className="opacity-75-hover text-primary me-1">the interviewee</a>
                                and their <br /> work following this is a transcript of the interview.
                            </div> */}
                        </div>
                    </div>
                    <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                        <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow">
                            <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-425px" >
                                <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                                    <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                                        <div className="text-center mb-10">
                                            <img
                                                alt='Logo'
                                                src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                                                className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                                            />
                                            <h3 className="card-title fw-bold signTitle">
                                                Verifying Your EmailAddress
                                            </h3>
                                        </div>
                                        {errorValues.isShow &&
                                            <div id="validationerror" className={errorValues.isError ? "alert alert-danger" : "alert alert-success"}>
                                                <strong>{errorValues.isError ? "Error!" : "Success"}</strong>
                                                <ul>
                                                    <li>{errorValues.message}</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className=" d-flex flex-stack">
                                    <div className="text-gray-500 text-center fs-6 mt-8">
                                        By clicking Sign In button, I agree to Livetecs
                                        <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                                            {('Terms Of Use')}
                                        </a> and <a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                                            {('Privacy Policy')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { EmailAddressVerification }